import LanguageSelectorOverlay from "@/shared/components/language/language-selector-overlay.vue";
import InfoMenu from "@/shared/components/menu/info-menu.vue";
import NotificationsMenu from "@/shared/components/menu/notifications/notifications-menu.vue";
import UserMenu from "@/shared/components/menu/user-menu.vue";
import { insertObjectAtPosition } from "../helpers/sort-helper";
import { MenuEntryWithMetaData } from "@/shared/environment/ability.types";
import { MenuEntry } from "@/shared/components/menu/menu.model";
import { computed, ComputedRef } from "vue";
import { useStaticPages } from "@/shared/composables/static-pages";

export function useMenuItems(): ComputedRef<MenuEntry[]> {
    const { staticPages, loading: staticPageLoading } = useStaticPages();

    return computed<MenuEntry[]>(() => {
        if (staticPageLoading.value) return [];

        const staticMenuItems: MenuEntryWithMetaData[] = [
            {
                position: 1,
                entry: {
                    id: "language-menu",
                    visible: true,
                    component: {
                        getComponent: () => LanguageSelectorOverlay,
                        props: {
                            icon: "fa-regular fa-earth-americas icon-color",
                            mobileIcon: "fa-regular fa-earth-americas text-on-navbar-color",
                        },
                    },
                },
            },
            {
                position: 2,
                entry: {
                    id: "info-menu",
                    visible: staticPages.value.length > 0,
                    component: {
                        getComponent: () => InfoMenu,
                        props: {
                            icon: "fa-regular fa-circle-info icon-color",
                            mobileIcon: "fa-regular fa-circle-info text-on-navbar-color",
                            menuTitleTranslationKey: "shared.Info",
                            staticPages: staticPages.value,
                        },
                    },
                },
            },
            {
                position: 3,
                entry: {
                    id: "notifications-menu",
                    visible: true,
                    component: {
                        getComponent: () => NotificationsMenu,
                        props: {
                            icon: "fa-regular fa-bell icon-color",
                            mobileIcon: "fa-regular fa-bell text-on-navbar-color",
                            menuTitleTranslationKey: "shared.Notifications",
                        },
                    },
                },
            },
            {
                position: 4,
                entry: {
                    id: "user-menu",
                    visible: true,
                    component: {
                        getComponent: () => UserMenu,
                        props: {
                            icon: "fa-regular fa-circle-user icon-color",
                            mobileIcon: "fa-regular fa-circle-user text-on-navbar-color",
                        },
                    },
                },
            },
        ];

        const menuItems = [...staticMenuItems];
        const menuEntries: MenuEntryWithMetaData[] = [];
        menuItems.forEach((item) => {
            insertObjectAtPosition<MenuEntryWithMetaData>(menuEntries, item, item.position);
        });
        return menuEntries.map((item) => item.entry);
    });
}
